export const extensionRoutes = [  {
    path: 'extensions/banners',
    loadChildren: () => import('./extensions/a6d7fb93a3201aab94d0e39580f7c1ea280a17a0e14443b4d81bdb68f5a83a90/banner.module').then(m => m.BannerModule),
  }];
